import _ from 'lodash'
import axios from 'axios'

export default class AppConfig {
  static items = {}

  /**
   * Load applications configuration, if no appconfig.json is found at
   * the root we will fall back to the environment variables.
   */
  static load () {
    return new Promise(async resolve => {
      if (_.get(process.env, 'VUE_APP_CONFIG_SRC') === 'env') {
        this.fromEnv()
        resolve()
      } else {
        await axios.get('/appconfig.json')
          .then(response => this.fromJson(response.data))
          .catch(() => this.fromEnv())
          .finally(() => {
            resolve()
          })
      }
    })
  }

  /**
   * Load items from the environment variables.
   */
  static fromEnv () {
    if (_.isObject(process.env)) {
      _.forIn(process.env, (v, k) => {
        if (k.substring(0, 8) === 'VUE_APP_') {
          this.items[k.substring(8).toLowerCase()] = v
        } else {
          this.items[k.toLowerCase()] = v
        }
      })
    }
  }

  /**
   * Load items in from a json configuration.
   */
  static fromJson (json) {
    this.items = json
  }

  /**
   * Retrieve a configuration item.
   *
   * @param {String} key
   * @returns
   */
  static get (key) {
    return _.get(this.items, key)
  }
}
